document.addEventListener('DOMContentLoaded', function () {

  function getWordLimits() {
    let wordLimit = 23;
    if (window.innerWidth < 980) {
      wordLimit = 14;
    }

    let titleLimit = 8;
    if (window.innerWidth > 1580) {
      titleLimit = 12;
    } else if (window.innerWidth > 1280) {
      titleLimit = 8;
    }

    return { wordLimit, titleLimit };
  }

  const sections = document.querySelectorAll('[data-jdgm-featured]');
  if (!sections.length) return;

  function buildAllSections() {
    const { wordLimit, titleLimit } = getWordLimits();

    sections.forEach(function (sectionEl) {
      const source = sectionEl.querySelector('.jdgm-featured-source');
      const targetInner = sectionEl.querySelector('.product-list__inner');
      if (!source || !targetInner) return;

      const limit = parseInt(sectionEl.getAttribute('data-count') || '12', 10);
      const cards = source.querySelectorAll('.jdgm-card.jdgm-testimonial');
      if (!cards.length) return;

      targetInner.innerHTML = '';

      function truncateText(html) {
        const textOnly = html.replace(/<[^>]*>/g, '').trim();
        const words = textOnly.split(/\s+/);

        if (words.length <= wordLimit) {
          return { short: html, full: null };
        }

        return {
          short: words.slice(0, wordLimit).join(' '),
          full: html
        };
      }

      Array.prototype.slice.call(cards, 0, limit).forEach(function (card, index) {
        const textBlock = card.querySelector('.jdgm-text');
        const bodyHtml = textBlock ? textBlock.innerHTML.trim() : '';

        let title = bodyHtml.replace(/<[^>]*>/g, '').trim().split('.')[0];
        let titleWords = title.split(/[,\s]+/);

        if (titleWords.length > titleLimit) {
          title = titleWords.slice(0, titleLimit).join(' ') + '..';
        }

        const starsOn = card.querySelectorAll('.jdgm-star.jdgm--on').length;
        const starsCount = starsOn || 5;

        const nameNode = card.querySelector('.jdgm-reviewer-name');
        const name = nameNode ? nameNode.textContent.trim() : '';

        const verifiedNode = card.querySelector('.jdgm-reviewer-verified-icon');
        const verifiedHtml = verifiedNode ? verifiedNode.outerHTML : '';

        const truncated = truncateText(bodyHtml);

        const item = document.createElement('product-item');
        item.classList.add('product-item');
        item.id = 'review-' + (index + 1);

        item.innerHTML =
          '<h3>' + title + '</h3>' +
          '<div class="star-rating">' +
            new Array(starsCount + 1).join('<span class="star">★</span>') +
          '</div>' +
          '<div class="testimonial__content">' +
            '<p class="review-text">' +
              truncated.short +
              (truncated.full
                ? ' <span class="toggle-review" style="color:#3ab54b;cursor:pointer;">... more</span>'
                : '') +
            '</p>' +
            (truncated.full
              ? '<div class="full-review" style="display:none;">' +
                  truncated.full +
                  ' <span class="toggle-review" style="color:#3ab54b;cursor:pointer;">... less</span>' +
                '</div>'
              : '') +
          '</div>' +
          '<p class="testimonial__author">' + name + ' ' + verifiedHtml + '</p>';

        targetInner.appendChild(item);

        if (truncated.full) {
          const toggles = item.querySelectorAll('.toggle-review');
          const full = item.querySelector('.full-review');
          const teaser = item.querySelector('.review-text');

          toggles.forEach(function (btn) {
            btn.addEventListener('click', function () {
              const open = full.style.display === 'block';
              full.style.display = open ? 'none' : 'block';
              teaser.style.display = open ? 'block' : 'none';
            });
          });
        }
      });
    });
  }

  // Poll only until Judge.me cards exist
  let attempts = 0;
  const timer = setInterval(function () {
    attempts += 1;
    const hasCards = document.querySelector('.jdgm-card.jdgm-testimonial');
    if (hasCards) {
      buildAllSections();
      clearInterval(timer);
    }
    if (attempts > 30) {
      clearInterval(timer);
    }
  }, 300);

  // Rebuild on resize so limits adapt
  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(buildAllSections, 300);
  });

});
